var _rect, _rect2, _path, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBringToFront(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.4,
    y: -0.4,
    width: 17.2,
    height: 17.2,
    rx: 1.6,
    transform: "matrix(1 0 0 -1 0 17.2)",
    fill: "#1E3A8A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.4,
    y: -0.4,
    width: 17.2,
    height: 17.2,
    rx: 1.6,
    transform: "matrix(1 0 0 -1 0 17.2)",
    stroke: "#1E3A8A",
    strokeWidth: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2828 4.71716C13.1266 4.56095 12.8734 4.56095 12.7172 4.71716L10.1716 7.26274C10.0154 7.41895 10.0154 7.67222 10.1716 7.82843C10.3278 7.98464 10.581 7.98464 10.7373 7.82843L13 5.56569L15.2627 7.82843C15.419 7.98464 15.6722 7.98464 15.8284 7.82843C15.9846 7.67222 15.9846 7.41895 15.8284 7.26274L13.2828 4.71716ZM13.4 12L13.4 5L12.6 5L12.6 12L13.4 12Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 5,
    width: 6,
    height: 3,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 9,
    width: 6,
    height: 1,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 11,
    width: 6,
    height: 1,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBringToFront);
export default __webpack_public_path__ + "static/media/Bring_To_Front.55a6093016af6623f6d50948ee1a8fa1.svg";
export { ForwardRef as ReactComponent };